var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeranstaltungen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#2C2B3D",
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240-40v-360h-80q-42 0-71-29t-29-71q0-42 29-71t71-29h80v-40h-80q-42 0-71-29t-29-71q0-42 29-71t71-29h80v-80h80v80h80q42 0 71 29t29 71q0 42-29 71t-71 29h-80v40h80q42 0 71 29t29 71q0 42-29 71t-71 29h-80v360h-80Zm-80-440h240q8 0 14-6t6-14q0-8-6-14t-14-6H160q-8 0-14 6t-6 14q0 8 6 14t14 6Zm0-240h240q8 0 14-6t6-14q0-8-6-14t-14-6H160q-8 0-14 6t-6 14q0 8 6 14t14 6ZM600-40v-80h80v-286q-53-14-86.5-56.5T560-560v-360h320v360q0 55-33.5 97.5T760-406v286h80v80H600Zm120-440q33 0 56.5-23.5T800-560v-80H640v80q0 33 23.5 56.5T720-480Zm-80-240h160v-120H640v120ZM140-480v-40 40Zm0-240v-40 40Zm580 80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeranstaltungen);
export default __webpack_public_path__ + "static/media/veranstaltungen.8e1f390342b8d2f3b9382a70bc3b42d9.svg";
export { ForwardRef as ReactComponent };